import * as React from 'react';
import { forwardRef } from 'react';
const Bancontact = (props, ref) => {
    const prefixId = React.useId();
    return (React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props },
        React.createElement("g", { clipPath: `url(#$${prefixId}__clip0_2180_915)` },
            React.createElement("path", { d: "M10 .5h20a9.5 9.5 0 0 1 9.5 9.5v20a9.5 9.5 0 0 1-9.5 9.5H10A9.5 9.5 0 0 1 .5 30V10A9.5 9.5 0 0 1 10 .5Z", fill: "#fff", stroke: "#EEE" }),
            React.createElement("path", { d: "M11.25 26.25c4.52 0 6.49-3.236 8.75-6.25H5v6.25h6.25Z", fill: `url(#$${prefixId}__paint0_linear_2180_915)` }),
            React.createElement("path", { d: "M28.75 13.75c-4.52 0-6.49 3.236-8.75 6.25h15v-6.25h-6.25Z", fill: `url(#$${prefixId}__paint1_linear_2180_915)` })),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: `$${prefixId}__paint0_linear_2180_915`, x1: 8.034, y1: 23.069, x2: 19.007, y2: 18.994, gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#005AB9" }),
                React.createElement("stop", { offset: 1, stopColor: "#1E3764" })),
            React.createElement("linearGradient", { id: `$${prefixId}__paint1_linear_2180_915`, x1: 20.908, y1: 20.3, x2: 32.559, y2: 16.325, gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#FBA900" }),
                React.createElement("stop", { offset: 1, stopColor: "#FFD800" })),
            React.createElement("clipPath", { id: `$${prefixId}__clip0_2180_915` },
                React.createElement("rect", { width: 40, height: 40, rx: 10, fill: "#fff" })))));
};
const ForwardRef = forwardRef(Bancontact);
export default ForwardRef;
ForwardRef.displayName = 'Bancontact';
//# sourceMappingURL=Bancontact.js.map